import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { blank } from '@web/utils';
import { AuthService } from '@web/shared/module/auth';

@Injectable({
  providedIn: 'root',
})
export class RefreshTokenService {
  private readonly auth = inject(AuthService);

  private readonly refreshedSource$ = new BehaviorSubject<boolean>(false);
  private readonly refreshingSource$ = new BehaviorSubject<boolean>(false);

  public get refreshing$(): Observable<boolean> {
    return this.refreshingSource$.asObservable();
  }

  public get refreshed$(): Observable<boolean> {
    return this.refreshedSource$.asObservable();
  }

  public refresh(): Observable<void> {
    this.refreshingSource$.next(true);
    this.refreshedSource$.next(false);

    return this.auth.refreshToken().pipe(
      tap({
        next: () => {
          this.refreshingSource$.next(false);
          this.refreshedSource$.next(true);
        },
        error: () => {
          this.refreshingSource$.next(false);
          this.refreshedSource$.next(false);
        },
      }),
      blank(),
    );
  }
}
